import { notification } from 'antd';

/**
 * Check if error message should be suppressed (hidden from user)
 * Silently suppresses JWT, token, and network-related errors
 */
const shouldSuppressError = (message: string): boolean => {
	if (!message) return false;

	const suppressedKeywords = [
		'jwt must be provided',
		'jwt expired',
		'invalid token',
		'token not found',
		'unauthorized',
		'network error',
		'network request failed',
		'enotfound',
		'econnrefused',
		'etimedout',
		'no network connection',
		'authorization token is required'
	];

	const lowerMessage = message.toLowerCase().trim();
	return suppressedKeywords.some(keyword => lowerMessage.includes(keyword));
};

export const openNotificationWithIcon = ({ type, message }) => {
	// Suppress JWT, token, and network errors - don't show to user
	if (shouldSuppressError(message)) {
		console.warn(`[Suppressed ${type}]`, message);
		return;
	}

	notification[type]({ message: message });
};
